const rxOne = /^[\],:{}\s]*$/;
const rxTwo = /\\(?:["\\\/bfnrt]|u[0-9a-fA-F]{4})/g;
const rxThree = /"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g;
const rxFour = /(?:^|:|,)(?:\s*\[)+/g;
const isJSON = (input) => (
    input.length && rxOne.test(
        input.replace(rxTwo, '@')
            .replace(rxThree, ']')
            .replace(rxFour, '')
    )
);

export function handleResponse(response) {
    if (response.ok) {
        return response.text().then((text) => {
            const responseBody = isJSON(text) ? JSON.parse(text) : {};
            return { hasErrors: false, data: responseBody };
        });
    }

    if (response.status >= 400 && response.status < 500) {
        return response.text().then((errorMessage) => {
            return { hasErrors: true, errorMessage };
        });
    }

    return { hasErrors: true, errorMessage: 'Network error.' };
}

// TODO: add different kind of logging
export function handleError(error) {
    // eslint-disable-next-line no-console
    console.error('API call failed. ' + error);
    return { hasErrors: true, errorMessage: 'Network error.' };
}
